module.exports = __webpack_public_path__ + "img/904.379305b7.png";